import { useContext } from 'react';
import { PrebidContext, PrebidContextType } from '../components/PrebidProvider';

export const usePrebid = (): PrebidContextType => {
  const context = useContext(PrebidContext);
  if (!context) {
    throw new Error('usePrebid must be used within a PrebidProvider');
  }
  return context;
};